package ru.villawonka.app.data.entity.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.data.entity.dto.AccommodationTypeDto
import ru.villawonka.app.data.entity.dto.ConversionDetailsDto
import ru.villawonka.app.data.entity.dto.CountryDto
import ru.villawonka.app.data.entity.dto.CurrencyDto
import ru.villawonka.app.data.entity.dto.PostSourceDto
import ru.villawonka.app.data.entity.dto.RentTypeDto
import ru.villawonka.app.data.entity.dto.toAccommodationAdditionDomainOrNull
import ru.villawonka.app.data.entity.dto.toDomain
import ru.villawonka.app.domain.model.PostDomain

@Serializable
data class AccommodationPostResponse(
    @SerialName("id") val id: Int,
    @SerialName("city") val city: String,
    @SerialName("district") val district: String,
    @SerialName("country") val country: CountryDto,
    @SerialName("description") val description: String,
    @SerialName("media") val media: List<String>,

    @SerialName("rent_type") val rentType: RentTypeDto,
    @SerialName("rent_from") val rentFrom: String? = null,
    @SerialName("rent_to") val rentTo: String? = null,

    @SerialName("original_cost") val originalCost: Int,
    @SerialName("original_deposit") val originalDeposit: Int? = null,
    @SerialName("original_currency") val originalCurrency: CurrencyDto,

    @SerialName("display_cost") val displayCost: Int? = null,
    @SerialName("display_deposit") val displayDeposit: Int? = null,
    @SerialName("display_currency") val displayCurrency: CurrencyDto? = null,

    @SerialName("cost_conversation_details")
    val costConversationDetails: ConversionDetailsDto? = null,

    @SerialName("accommodation_type") val accommodationType: AccommodationTypeDto,
    @SerialName("additions") val additions: List<String>? = null,
    @SerialName("bedrooms") val bedrooms: Int? = null,
    @SerialName("bathrooms") val bathrooms: Int? = null,

    @SerialName("mentioned_usernames") val mentionedUsernames: List<String>? = null,
    @SerialName("mentioned_phone_numbers") val mentionedPhoneNumbers: List<String>? = null,

    @SerialName("contact_user_id") val contactUserId: Long,
    @SerialName("contact_username") val contactUsername: String? = null,

    @SerialName("is_liked") val isLiked: Boolean,
    @SerialName("is_new") val isNew: Boolean,

    @SerialName("source") val source: PostSourceDto? = null,

    @SerialName("updated_at") val updatedAt: String,
    @SerialName("created_at") val createdAt: String,
)

fun AccommodationPostResponse.toDomain() = PostDomain.Accommodation(
    id = id,
    city = city,
    district = district,
    country = country.toDomain(),
    description = description,
    media = media,
    rentType = rentType.toDomain(),
    rentFrom = rentFrom,
    rentTo = rentTo,
    originalCost = originalCost,
    originalDeposit = originalDeposit,
    originalCurrency = originalCurrency.toDomain(),
    displayCost = displayCost,
    displayDeposit = displayDeposit,
    displayCurrency = displayCurrency?.toDomain(),
    costConversationDetails = costConversationDetails?.toDomain(),
    accommodationType = accommodationType.toDomain(),
    additions = additions?.mapNotNull { it.toAccommodationAdditionDomainOrNull() },
    bedrooms = bedrooms,
    bathrooms = bathrooms,
    mentionedUsernames = mentionedUsernames,
    mentionedPhoneNumbers = mentionedPhoneNumbers,
    contactUserId = contactUserId,
    contactUsername = contactUsername,
    source = source?.toDomain(),
    isLiked = isLiked,
    isNew = isNew,
    updatedAt = updatedAt,
    createdAt = createdAt
)


















